<template>
  <header-menu></header-menu>
  <router-view/>
  <footer-menu></footer-menu>
</template>

<script>
import HeaderMenu from './components/HeaderMenu.vue'
import FooterMenu from './components/Footer.vue'
export default {
  name: 'App',
  components: {
    HeaderMenu,
    FooterMenu
  }
}
</script>

<style lang="scss">

/* 定义整个滚动条的样式 */
::-webkit-scrollbar {
  width: 0px; /* 滚动条的宽度 */
  height: 0px; /* 滚动条的高度 */
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
html,body {
  margin: 0;
  width: 100%;
  // background-color: #EFF3FC;
  background-color: #fff;
  display: flex;
  justify-content: center;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none;   /* Chrome, Opera, Safari */
  -khtml-user-select: none;    /* Konqueror */
  -moz-user-select: none;      /* Firefox */
  -ms-user-select: none;       /* Internet Explorer/Edge */
  user-select: none;
  -webkit-user-drag: none;

}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
